import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

const neighborhoods = [
  { name: "Brickell", slug: "brickell" },
  { name: "Aventura", slug: "aventura" },
  { name: "Miami Beach", slug: "miami-beach" },
  { name: "Coral Gables", slug: "coral-gables" },
  { name: "Coconut Grove", slug: "coconut-grove" },
  { name: "Doral", slug: "doral" },
  { name: "Kendall", slug: "kendall" },
  { name: "Pinecrest", slug: "pinecrest" },
  { name: "Bay Harbor Islands", slug: "bay-harbor-islands" },
  { name: "Key Biscayne", slug: "key-biscayne" },
  { name: "South Miami", slug: "south-miami" },
  { name: "North Miami Beach", slug: "north-miami-beach" },
];

export default function ServiceAreasPreviewSection() {
  const { t } = useLanguage();

  return (
    <section className="w-full bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-black text-secondary mb-3">
            {t("home.areasTitle")}
          </h2>
          <p className="text-sm md:text-base text-[#374151]">
            {t("home.areasSub")}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mb-8">
          {neighborhoods.map((n) => (
            <Link
              key={n.slug}
              to={`/impact-windows-${n.slug}/`}
              className="flex items-center justify-center px-4 py-3 bg-[#fefce8] text-secondary font-medium text-sm rounded-full hover:bg-primary hover:text-white transition-colors whitespace-nowrap"
            >
              {t("home.areaBtnPrefix")} {n.name}
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/service-areas"
            className="inline-flex items-center gap-2 border-2 border-[#ea580c] text-[#ea580c] px-6 py-2.5 text-sm font-bold rounded-lg hover:bg-[#ea580c] hover:text-white transition-colors whitespace-nowrap"
          >
            {t("home.viewAllAreas")}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}